/**
 * IONLOOP Assistant — deterministic answer templates.
 *
 * Each template assembles a structured, renderer-safe response object. No
 * free-form language generation — components are always source-backed strings
 * supplied by the composer.
 */

function base(status, type, confidence) {
    return {
        status: status,
        type: type,
        title: '',
        intro: '',
        paragraphs: [],
        bullets: [],
        steps: [],
        actions: [],
        sources: [],
        followUps: [],
        confidence: confidence || 0,
        trace: []
    };
}

function definition(parts) {
    var r = base('answered', 'definition', parts.confidence);
    r.title = parts.title || '';
    r.intro = parts.intro || '';
    r.paragraphs = parts.paragraphs || [];
    r.bullets = parts.bullets || [];
    r.actions = parts.actions || [];
    r.sources = parts.sources || [];
    r.followUps = parts.followUps || [];
    r.trace = parts.trace || [];
    return r;
}

function howTo(parts) {
    var r = base('answered', 'how-to', parts.confidence);
    r.title = parts.title || '';
    r.intro = parts.intro || 'Based on the available IONLOOP content:';
    r.steps = parts.steps || [];
    r.paragraphs = parts.paragraphs || [];
    r.actions = parts.actions || [];
    r.sources = parts.sources || [];
    r.followUps = parts.followUps || [];
    r.trace = parts.trace || [];
    return r;
}

function navigation(parts) {
    var r = base('answered', 'navigation', parts.confidence);
    r.title = parts.title || '';
    r.intro = parts.intro || '';
    r.paragraphs = parts.paragraphs || [];
    r.actions = parts.actions || [];
    r.sources = parts.sources || [];
    r.followUps = parts.followUps || [];
    r.trace = parts.trace || [];
    return r;
}

function capability(parts) {
    var r = base('answered', 'capability', parts.confidence);
    r.title = parts.title || '';
    r.intro = parts.intro || '';
    r.paragraphs = parts.paragraphs || [];
    r.bullets = parts.bullets || [];
    r.actions = parts.actions || [];
    r.sources = parts.sources || [];
    r.followUps = parts.followUps || [];
    r.trace = parts.trace || [];
    return r;
}

function overview(parts) {
    var r = base('answered', 'overview', parts.confidence);
    r.title = parts.title || '';
    r.intro = parts.intro || 'IONLOOP brings several areas into one workspace:';
    r.bullets = parts.bullets || [];
    r.paragraphs = parts.paragraphs || [];
    r.actions = parts.actions || [];
    r.sources = parts.sources || [];
    r.followUps = parts.followUps || [];
    r.trace = parts.trace || [];
    return r;
}

function comparison(parts) {
    var r = base('answered', 'comparison', parts.confidence);
    r.title = parts.title || '';
    r.intro = parts.intro || '';
    r.paragraphs = parts.paragraphs || [];
    r.bullets = parts.bullets || [];
    r.actions = parts.actions || [];
    r.sources = parts.sources || [];
    r.followUps = parts.followUps || [];
    r.trace = parts.trace || [];
    return r;
}

function support(parts) {
    var r = base('answered', 'support', parts.confidence);
    r.title = parts.title || '';
    r.intro = parts.intro || '';
    r.paragraphs = parts.paragraphs || [];
    r.actions = parts.actions || [];
    r.sources = parts.sources || [];
    r.followUps = parts.followUps || [];
    r.trace = parts.trace || [];
    return r;
}

function ambiguous(parts) {
    var r = base('ambiguous', 'ambiguous', parts.confidence);
    r.intro = parts.intro || 'I found several related topics. What would you like to know?';
    r.bullets = parts.bullets || [];
    r.suggestions = parts.suggestions || [];
    r.sources = parts.sources || [];
    return r;
}

function insufficient(parts) {
    var r = base('insufficient', 'insufficient', parts.confidence);
    r.intro = parts.intro ||
        "I couldn't find enough information about that in the IONLOOP knowledge base.";
    r.paragraphs = parts.paragraphs || [];
    r.sources = parts.sources || [];
    return r;
}

module.exports = {
    definition: definition,
    howTo: howTo,
    navigation: navigation,
    capability: capability,
    overview: overview,
    comparison: comparison,
    support: support,
    ambiguous: ambiguous,
    insufficient: insufficient
};
